import {useAppDispatch} from 'core/redux/hooks/useAppDispatch';
import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {useGetProductInCart} from 'hooks/product/useGetProductInCart';
import {ICartProduct} from 'modules/cart/models';
import {useAddToCartMutation} from 'modules/cart/services';
import {actionSetAddedProduct} from 'modules/cart/slice';
import {selectProductData} from 'modules/product-card/selectors';
import {setProductCounterCount} from 'modules/product-card/thunks';
import {useCallback, useContext} from 'react';
import {useCartEventAnalytics} from 'modules/products/hooks/gtag/useCartEventAnalytics';
import {ProductPageContext} from 'modules/product-card/context';
import {IAnalyticsMeta} from 'core/types';

const QUANTITY = 1;

export const useAddProductInCart = () => {
    const {reviewsTotal} = useContext(ProductPageContext);
    const productData = useAppSelector(selectProductData);

    const cartEventGtag = useCartEventAnalytics();

    const dispatch = useAppDispatch();
    const product = useAppSelector(selectProductData);
    const productInCart = useGetProductInCart();
    const [updateCart] = useAddToCartMutation();

    return useCallback(
        // eslint-disable-next-line @typescript-eslint/naming-convention
        async (analytics?: IAnalyticsMeta) => {
            if (!product) {
                return;
            }

            if (productInCart) {
                return;
            }

            const {offerId} = product;

            try {
                const response = await updateCart({
                    offerId,
                    quantity: QUANTITY,
                }).unwrap();

                const newProduct = response.products.find((item) => item.offerId === offerId);

                if (!newProduct) {
                    return;
                }

                dispatch(setProductCounterCount(QUANTITY));
                dispatch(actionSetAddedProduct(newProduct as ICartProduct));

                if (productData) {
                    cartEventGtag?.(productData, QUANTITY, analytics, reviewsTotal);
                }
            } catch (e) {
                console.error(e);
            }
        },
        [cartEventGtag, dispatch, product, productData, productInCart, reviewsTotal, updateCart],
    );
};
